export default "__VITE_ASSET__2ocHX6l7__"